export default __webpack_public_path__ + "static/media/situation-coref-assign-situation-type.0b7f7466.gif";